module.exports = __webpack_public_path__ + "static/media/04__CALCINHA_LATERAL_DRAPEADA_ESTAMPADA_10.c3d2ed90.jpg";